module.exports = __webpack_public_path__ + "img/Weapon_239.b87233a1.png";